import React, { useState } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import Grid from "@mui/material/Grid2";

import {
  DescriptionCard,
  DraggableCard,
  PenPortraitCard,
  TopBrandsCard,
} from "@/components/atoms";
import { DemographicsSection, PenPortraitMap } from "@/components/molecules";
import { useInsightFilters } from "@/context";
import {
  InsightMeta,
  InsightResult,
  LocationResult,
  PenPortrait,
} from "@/types";
import { getClientComponent } from "@/utils";

interface PenPortraitViewProps {
  meta: InsightMeta;
  insights: InsightResult[];
  pen_portrait: PenPortrait;
  locations: LocationResult;
}

export const PenPortraitView: React.FC<PenPortraitViewProps> = ({
  meta,
  insights,
  pen_portrait,
  locations,
}) => {
  const {
    filters: { scoreType, levels },
  } = useInsightFilters();

  const [sections, setSections] = useState(pen_portrait.sections);

  const handleMoveCard = (dragIndex: number, hoverIndex: number) => {
    const updatedSections = [...sections];
    // Swap the card positions
    [updatedSections[hoverIndex], updatedSections[dragIndex]] = [
      updatedSections[dragIndex],
      updatedSections[hoverIndex],
    ];
    setSections(updatedSections);
  };

  const handleRemoveSection = (index: number) => {
    const updatedSections = sections.filter((_, i) => i !== index);
    setSections(updatedSections);
  };

  const ClientDemographicsSection = getClientComponent('DemographicsSection', DemographicsSection);

  return (
    <Grid container size={12} spacing={2}>
      <Grid container size={12} justifyContent="space-between">
        <Grid container size={8} alignContent="space-around">
          <ClientDemographicsSection
            insights={insights}
            score={scoreType.value}
          />
          {/*<Grid size={12}>*/}
          {/*  <TopBrandsCard*/}
          {/*    variables={pen_portrait.top_scores}*/}
          {/*    score={scoreType.value}*/}
          {/*    levels={levels}*/}
          {/*    />*/}
          {/*</Grid>*/}
          <Grid size={12}>
            <DescriptionCard description={meta.description_short} />
          </Grid>
        </Grid>
        <Grid size={4}>
          <PenPortraitMap scores={locations} />
        </Grid>
      </Grid>

      <DndProvider backend={HTML5Backend}>
        {sections.map((section, index) => {
          const variables = pen_portrait.insight.filter(
            (v) => v.section === section.title,
          )[0].variables;
          return (
            <Grid size={4} key={`pen-portrait-${index}`}>
              <DraggableCard
                index={index}
                onMoveCard={handleMoveCard}
                type="card"
              >
                <PenPortraitCard
                  title={section.title}
                  variables={variables}
                  score={scoreType.value}
                  levels={levels}
                  onRemoveSection={() => handleRemoveSection(index)}
                />
              </DraggableCard>
            </Grid>
          );
        })}
      </DndProvider>
    </Grid>
  );
};

export default PenPortraitView;
